import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { ToastService } from 'src/app/services/toast.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})
export class SignupPage implements OnInit {
  ionicForm: FormGroup;
  isSubmitted = false;
  name: any;
  email: any;
  password: any;
  confirmPassword: any;
  rcode: any;
  userId: any;
  constructor(private routerActivate: ActivatedRoute, private formBuilder: FormBuilder, private toast: ToastService, private router: Router, private authService: StoreService,) {
    this.routerActivate.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation().extras.state) {
        this.userId = this.router.getCurrentNavigation().extras.state.userId;
      }
      console.log("at time of cons in build profile receive", this.userId)
    });
    this.ionicForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.email]],
      password: ['', [Validators.required,Validators.minLength(8)]],
      cpassword: ['', [Validators.required,Validators.minLength(8)]],
      phone: ['', [Validators.required, Validators.pattern('^[0-9_-]{10,12}')]],
      rcode: ['', []],
    });
  }
  get errorControl() {
    return this.ionicForm.controls;
  }
  ngOnInit() {

  }
  //This is flow for OTP (Sprint-7) new branch in this repo depoloy flow for Remove OTP flow and use simple flow with out sending OTP.So create new register API add mobile number and not mandatory email filed.Create mail id random basis if user not enter email id.
  submitForm() {
    console.log(this.ionicForm.value)
    //this.authService.showLoader()
    this.isSubmitted = true;
    if(this.ionicForm.controls.name.errors?.required){
      this.toast.presentToast("Please enter your name")
      
    }
    else if(this.ionicForm.controls.phone.errors?.required){
      this.toast.presentToast("Please enter valid mobile number")
    }
    else if(this.ionicForm.controls.password.errors?.required){
      this.toast.presentToast("Please enter your password")
    }
    else if(this.ionicForm.controls.password.errors?.minlength){
      console.log("asd")
      this.toast.presentToast("Password must be contain atleast 8 characters")
    }
    else if(this.ionicForm.controls.cpassword.errors?.required){
      
      this.toast.presentToast("Confirm password must be same as password")
    }
   
    else if (!this.ionicForm.valid) {
      this.toast.presentToast("Please enter all required field")
      return;
    } else {
      const Signupobj = {
        // userId: this.userId,
        name: this.ionicForm.value.name,
        email: this.ionicForm.value.email.trim(),
        pwd: this.ionicForm.value.password,
        phone: this.ionicForm.value.phone,
        toReferralCode: this.ionicForm.value.rcode
      }
      console.log("Sending Signup API form dtata", Signupobj)

      if (this.ionicForm.value.password == this.ionicForm.value.cpassword) {
        this.authService.signup(Signupobj).subscribe((result: any) => {
          if (result.code == 0) {
            this.toast.presentToast(result.msg)
          }
          else {
            this.router.navigate(['login'])
            this.toast.presentToast("Thanks for registering with us !")
          }
        }, (error: any) => {
          this.toast.presentToast("Error fron there" + error)
        });
      }
      else {
        this.toast.presentToast("Confirm Password Doesn't Match With Your Password")
      }
    }
  }
  navigateToWelcome() {
    this.router.navigate(['loginn'])
  }

  goBack() {
    this.router.navigate(['loginn'])
  }
}

